import { useState, useEffect, useRef } from 'react';
import './MainMenu.css';
import Cookies from 'js-cookie';
import TheProject from '../subMenu/TheProject';
import Join from '../subMenu/Join';

const MainMenu = () => {
	const refs = {
		1: useRef(null),
		2: useRef(null),
		3: useRef(null),
		4: useRef(null),
		5: useRef(null),
	};
	const [idSelected, setIdSelected] = useState(1);
	const [idActivated, setIdActivated] = useState(1);
	const [rightFocus, setRightFocus] = useState(false);
	const contentRef = useRef(null);

	// Mise à jour de la sélection lorsque idSelected change
	useEffect(() => {
		const selectedMenu = {
			1: 'The Project',
			2: 'Origins',
			3: 'Posts',
			4: 'Join',
			5: 'Home',
		}[idSelected];
		setMenuSelected(selectedMenu);

		refs[idSelected].current.focus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [idSelected]);

	useEffect(() => {
		const activatedMenu = {
			1: 'The Project',
			2: 'Origins',
			3: 'Posts',
			4: 'Join',
			5: 'Home',
		}[idActivated];
		setCurrentMenu(activatedMenu);
		refs[idActivated].current.focus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [idActivated]);

    const scrollTo = (location) => {
        window.scrollTo(location, true, 'top');
    };

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (!rightFocus) {
                
                
				if (event.key === 'ArrowUp') {
                    event.preventDefault(); 
					setIdSelected(idSelected > 1 ? idSelected - 1 : 5);
				} else if (event.key === 'ArrowDown') {
                    event.preventDefault(); 
					setIdSelected(idSelected < 5 ? idSelected + 1 : 1);
				} else if (event.key === 'ArrowRight' || event.key === 'Tab') {
					const itemFosus = document.getElementById('content-item-container-focus');
					itemFosus.classList.add('need-focus');
					setRightFocus(true);
					contentRef.current.focus();
				} else if (event.key === 'Enter') {
					if (idSelected === 5) {
						Cookies.remove('realWeb');
						Cookies.remove('mazeToken');
						window.location.reload();
					} else {
						setIdActivated(idSelected);
					}
				}
			} else {
                // contentRef.current.style.overflowY = "scroll";
				if (event.key === 'ArrowLeft' || event.key === 'Escape') {
                    scrollTo(refs[idSelected]);
					const unfocus = document.getElementById('content-item-container-focus');
					unfocus.classList.remove('need-focus');
					setRightFocus(false);
					refs[idSelected].current.focus();
				}
			}
		};
		window.addEventListener('keydown', handleKeyDown);

		// nettoyer l'écouteur d'événement lors du démontage du composant
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [idSelected, rightFocus]);


	const [menuSelected, setMenuSelected] = useState('The Project');
	const [currentMenu, setCurrentMenu] = useState('The Project');

	return (
		<section className="real-web-container">
			<nav
				className="real-web-primary-nav"
				id="nav-real-web"
			>   
            
				<ul className="list-menu">
                <div>↑ ↓</div>
					<li
						id="menu-1"
						ref={refs[1]}
						className={`${menuSelected === 'The Project' ? 'menu-item-selected' : 'menu-item-green'} ${currentMenu === 'The Project' && 'menu-item-activated'}`}
					>
						Le projet
					</li>
					<li
						id="menu-2"
						ref={refs[2]}
						className={`${menuSelected === 'Origins' ? 'menu-item-selected' : 'menu-item-green'} ${currentMenu === 'Origins' && 'menu-item-activated'}`}
					>
						Origines
					</li>
					<li
						id="menu-3"
						ref={refs[3]}
						className={`${menuSelected === 'Posts' ? 'menu-item-selected' : 'menu-item-green'} ${currentMenu === 'Posts' && 'menu-item-activated'}`}
					>
						Posts
					</li>
					<li
						id="menu-4"
						ref={refs[4]}
						className={`${menuSelected === 'Join' ? 'menu-item-selected' : 'menu-item-green'} ${currentMenu === 'Join' && 'menu-item-activated'}`}
					>
						Join
					</li>
					<li
						id="menu-5"
						ref={refs[5]}
						className={`${menuSelected === 'Home' ? 'menu-item-selected' : 'menu-item-green'} ${currentMenu === 'Home' && 'menu-item-activated'}`}
					>
						Home
					</li>
				</ul>
			</nav>
			<div
				className="real-web-content-item"
				id="content-item-container-focus"
				ref={contentRef}
			>
				<div>{currentMenu === 'The Project' && <TheProject></TheProject>}</div>
				<div>{currentMenu === 'Join' && <Join></Join>}</div>
			</div>
		</section>
	);
};

export default MainMenu;
